import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { byIdShape } from 'utils/propTypes';

import './styles.scss';


const Amenities = ({ amenities, placesById }) => {
  const amenitiesByType = {};

  const amenitiesMap = {
    '24-hour-lounge': '24 Hour Lounge',
    equipment: 'Equipment',
    'additional-navigation-ins': 'Additional Navigation Instructions',
    charging: 'Charging',
    'free-parking': 'Free parking',
    'other-public-charging': 'Other Public Charging',
    'snack-shop': 'Snack Shop',
    parking: 'Parking',
    'public-charging': 'Public Charging',
    wifi: 'WiFi',
    'local-highlight': 'Local Highlights',
    shopping: 'Shopping',
    hotel: 'Hotels',
    restaurant: 'Restaurants',
    delivery: 'Deliveries',
    amenity: 'Amenities',
    restroom: 'Restrooms',
  };

  amenities.forEach((amenity) => {
    if (amenitiesByType[amenity.amenity_type] === undefined) {
      amenitiesByType[amenity.amenity_type] = [];
    }
    let item;
    if (amenity.place && amenity.place in placesById) {
      const place = placesById[amenity.place];
      item = (
        <li key={amenity.pk}>
          <Link to={`/${place.category}/${place.pk}/`}>{ amenity.name }</Link>
        </li>
      );
    } else if (amenity.link) {
      item = (
        <li key={amenity.pk}>
          <a href={amenity.link} target='_blank' rel='noopener noreferrer'>{amenity.name}</a>
        </li>
      );
    } else {
      item = <li key={amenity.pk}>{amenity.name}</li>;
    }
    amenitiesByType[amenity.amenity_type].push(item);
  });

  const amenityTypes = Object.keys(amenitiesByType);

  amenityTypes.sort();

  const amenitiesByTypeList = amenityTypes.map(type => (
    <li className={`amenity amenity-type-${type}`} key={type}>
      <strong>{ amenitiesMap[type] }</strong>
      <ul>
        { amenitiesByType[type] }
      </ul>
    </li>
  ));

  return (
    <ul styleName='amenities'>
      { amenitiesByTypeList }
    </ul>
  );
};

Amenities.propTypes = {
  amenities: PropTypes.arrayOf(PropTypes.shape({
    pk: PropTypes.number,
    place: PropTypes.string,
    name: PropTypes.string,
    link: PropTypes.string,
  })).isRequired,
  placesById: byIdShape,
};

Amenities.defaultProps = {
  placesById: {},
};

export default Amenities;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Charger/components/Amenities/index.jsx